var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditGreyIcon = function SvgEditGreyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.0000262px",
    height: "13.0000095px",
    viewBox: "0 0 13.0000262 13.0000095",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.2.9-Setup-/-Company-/-Company-details---create-project--view-action",
    transform: "translate(-1007.500000, -556.012403)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-action",
    transform: "translate(988.000000, 526.511337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(0.000000, 14.001075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-1",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.Icon/01.Basic/Fill/20/eye",
    transform: "translate(3.500000, 3.499991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8731251,0.1640719 C12.7808484,0.0626804785 12.6511107,0.00345148134 12.514055,0.00014608898 C12.3769992,-0.00315930338 12.2445571,0.049746666 12.1475001,0.1465719 L11.7609376,0.531259403 C11.6633837,0.628877206 11.6633837,0.787079102 11.7609376,0.884696905 L12.1153126,1.23844691 C12.1622297,1.28558282 12.2259944,1.31208197 12.2925001,1.31208197 C12.3590058,1.31208197 12.4227705,1.28558282 12.4696876,1.23844691 L12.8465626,0.863446905 C13.0371876,0.673134404 13.0550001,0.363134402 12.8731251,0.1640719 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9793751,1.31250941 L5.33812503,6.94375944 C5.30392177,6.97782362 5.27906182,7.02011783 5.26593753,7.06657194 L5.00500003,7.84375945 C4.99226583,7.88671861 5.00406624,7.93320185 5.03574943,7.96488505 C5.06743263,7.99656824 5.11391587,8.00836865 5.15687503,7.99563445 L5.93343754,7.73469695 C5.97989165,7.72157267 6.02218586,7.69671271 6.05625004,7.66250945 L11.6875001,2.02063441 C11.7959275,1.91104663 11.7959275,1.73459719 11.6875001,1.62500941 L11.3765626,1.31250941 C11.266792,1.2030473 11.0891457,1.2030473 10.9793751,1.31250941 L10.9793751,1.31250941 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5731251,4.55188443 L6.76406254,8.36844695 C6.61684409,8.51602567 6.43590234,8.62553458 6.23687504,8.68750945 L5.42750003,8.95844696 C5.03637489,9.06889974 4.61609576,8.95930597 4.32871214,8.67192234 C4.04132852,8.38453872 3.93173474,7.96425959 4.04218753,7.57313445 L4.31312503,6.76375944 C4.3749195,6.56479404 4.48421049,6.38385793 4.63156253,6.23657194 L8.44812505,2.42688441 C8.51966732,2.35542171 8.54111461,2.24789852 8.50246537,2.15445629 C8.46381613,2.06101406 8.37268234,2.00000941 8.27156255,2.00000941 L1.75000001,2.00000941 C0.783501693,2.00000941 0,2.7835111 0,3.75000942 L0,11.2500095 C0,12.2165078 0.783501693,13.0000094 1.75000001,13.0000094 L9.25000006,13.0000094 C10.2164984,13.0000094 11,12.2165078 11,11.2500095 L11,4.72844693 C11,4.62732714 10.9389954,4.53619335 10.8455532,4.49754411 C10.752111,4.45889487 10.6445878,4.48034216 10.5731251,4.55188443 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditGreyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-grey-icon.71b1cbcc.svg";
export { ForwardRef as ReactComponent };